import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      await addDoc(collection(db, 'contact_submissions'), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      await addDoc(collection(db, 'mail'), {
        to: 'xavier@watchmindi.tv',
        message: {
          subject: `New Contact Form — ${formData.subject} — ${formData.name}`,
          text: [
            `New Contact Form Submission`,
            '',
            `Name: ${formData.name}`,
            `Email: ${formData.email}`,
            `Subject: ${formData.subject}`,
            `Message:`,
            formData.message,
          ].join('\n'),
        },
      });

      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again or email synemafest@gmail.com.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-dark3 border border-teal/20 rounded p-10 text-center max-w-xl mx-auto"
      >
        <h3 className="font-display text-3xl text-teal mb-4">MESSAGE SENT</h3>
        <p className="text-[0.95rem] font-light text-white/60 leading-relaxed">
          Thanks for reaching out! We'll get back to you as soon as possible.
        </p>
        <p className="text-[0.75rem] text-muted mt-3">
          Don't see our reply? Check your spam or promotions folder for a message from synemafest@gmail.com.
        </p>
      </motion.div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="max-w-xl mx-auto space-y-5">
      {error && (
        <div className="bg-red-500/10 border border-red-500/20 rounded p-3 text-[0.85rem] text-red-400">
          {error}
        </div>
      )}

      <div>
        <label className="block font-mono text-[0.65rem] tracking-[0.2em] uppercase text-muted mb-2">Name</label>
        <input type="text" name="name" required value={formData.name} onChange={handleChange}
          className="w-full bg-dark3 border border-white/[0.06] rounded px-4 py-3 text-[0.9rem] text-white/90 font-light focus:border-teal/40 focus:outline-none transition-colors"
          placeholder="Your full name" />
      </div>

      <div>
        <label className="block font-mono text-[0.65rem] tracking-[0.2em] uppercase text-muted mb-2">Email</label>
        <input type="email" name="email" required value={formData.email} onChange={handleChange}
          className="w-full bg-dark3 border border-white/[0.06] rounded px-4 py-3 text-[0.9rem] text-white/90 font-light focus:border-teal/40 focus:outline-none transition-colors"
          placeholder="you@example.com" />
      </div>

      <div>
        <label className="block font-mono text-[0.65rem] tracking-[0.2em] uppercase text-muted mb-2">Subject</label>
        <select name="subject" required value={formData.subject} onChange={handleChange}
          className="w-full bg-dark3 border border-white/[0.06] rounded px-4 py-3 text-[0.9rem] text-white/90 font-light focus:border-teal/40 focus:outline-none transition-colors appearance-none">
          <option value="">Select a topic</option>
          <option value="General Inquiry">General Inquiry</option>
          <option value="Film Submissions">Film Submissions</option>
          <option value="Sponsorship">Sponsorship</option>
          <option value="Press">Press</option>
          <option value="Affiliates">Affiliates</option>
          <option value="Technical Support">Technical Support</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div>
        <label className="block font-mono text-[0.65rem] tracking-[0.2em] uppercase text-muted mb-2">Message</label>
        <textarea name="message" required rows={5} value={formData.message} onChange={handleChange}
          className="w-full bg-dark3 border border-white/[0.06] rounded px-4 py-3 text-[0.9rem] text-white/90 font-light focus:border-teal/40 focus:outline-none transition-colors resize-none"
          placeholder="How can we help?" />
      </div>

      <button
        type="submit"
        disabled={submitting}
        className={`w-full btn-gradient text-dark font-body text-[0.78rem] font-semibold tracking-[0.08em] uppercase py-4 px-6 rounded-sm transition-all ${
          submitting ? 'opacity-60 cursor-wait' : 'hover:opacity-90 hover:-translate-y-[1px]'
        }`}
      >
        {submitting ? 'Sending...' : 'Send Message'}
      </button>
    </form>
  );
};

export default ContactForm;
